<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="WarningIcon" alt="Warning Icon" width="40" height="40" />
      </div>
      <h4>{{ $t('approval_templates.modal_messages.confirm_activate_title') }}</h4>
      <p class="m-0 text-muted" v-html="confirmActivateDescription"></p>
    </div>
    <template #modal-footer>
      <div class="d-flex gap-3 w-100">
        <b-button
            class="w-50"
            variant="light"
            @click="handleCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
        <b-button
            class="w-50 m-0"
            variant="primary"
            @click="handleConfirm"
        >
          {{ $t('approval_templates.buttons.yes_activate') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import WarningIcon from '@/assets/icons/WarningIcon.svg'

export default {
  name: 'approval-template-activate-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'approval-template-activate-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      WarningIcon,
      targetModel: null,
    };
  },
  computed: {
    confirmActivateDescription() {
      const menu = this.lodash.escape(this.getApprovableTypeLabel(this.targetModel?.approvable_type))
      return this.$t('approval_templates.modal_messages.confirm_activate_description', {
        menu: `<strong>${menu}</strong>`
      })
    },
  },
  methods: {
    show(model) {
      this.targetModel = model ?? null
      this.$bvModal.show(this.id)
    },
    getApprovableTypeLabel(type) {
      const typeMap = this.$t('approval_templates.approvable_types');
      return typeMap[type] || type;
    },
    handleCancel() {
      this.hide()
      this.$emit('cancelled', this.targetModel)
    },
    handleConfirm() {
      this.hide()
      this.$emit('confirmed', this.targetModel)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
